import { googleLogout } from '@react-oauth/google';
import { signOut } from "firebase/auth";
import { NavigateFunction } from 'react-router-dom';
import axios from 'axios';
import { auth } from '../components/auth/firebaseConfig';
import { User } from '@/models/user';
import { Case } from '@/models/case';

export function logout(navigate: NavigateFunction | null) {
    cleanLocalStorage();
    googleLogout();
    signOut(auth);
    if (navigate && navigate !== null) {
        const isLegalbot = window.location.pathname.startsWith('/legalbot');
        navigate(isLegalbot ? '/legalbot' : '/');
    }
};

export function cleanLocalStorage() {
  localStorage.clear();
}

export function isValidRole(validRole: string, navigate: NavigateFunction) {
  const storedUser = localStorage.getItem('user');
  const parsedStoredUser =  storedUser ? JSON.parse(storedUser) : {};
  if (parsedStoredUser.role !== validRole) {
    console.log("invalid role", parsedStoredUser.role, validRole);
    navigate("/");
  }
};

export function isValidRoles(validRoles: string[], navigate: NavigateFunction) {
  const storedUser = localStorage.getItem('user');
  const parsedStoredUser = storedUser ? JSON.parse(storedUser) : null;

  const userRole = parsedStoredUser?.role;
  if (!userRole || !validRoles.includes(userRole)) {
    navigate('/');
  }
}

export function refreshToken(navigate: NavigateFunction | null): Promise<boolean> {
    return axios.post(`https://api.abogalia.com.ar/abogalia/api/v1/users/refresh_token`, {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('refresh_token')}`,
            Accept: 'application/json'
          }
        },
      )
      .then((res) => {
        if (res.status === 200) {
            localStorage.setItem("jwt", res.data.jwt);
            localStorage.setItem("refresh_token", res.data.refresh_token);
            return true;
        } else if (res.status === 401) {
            logout(navigate);
        }
        return false;
      })
      .catch(() => {
            logout(navigate);
            return false;
      });
}

export function isLawyerBlocked(user?: User) {
  return isLawyer(user) && user && user.verified_status === "blocked"
}

export function isLawyerVerified(user?: User) {
  return isLawyer(user) && user && user.verified_status === "verified"
}

export function isLawyerNotVerifiedYet(user?: User) {
  return isLawyer(user) && user && user.verified_status === null
}

export function isEmptyCase(case_?: Case) {
  return !case_ || Object.keys(case_).length === 0
}

export function isEmptyUser(user?: User) {
  return !user || Object.keys(user).length === 0
}

export function isLawyer(user?: User) {
  if (isEmptyUser(user)) {
    return false;
  }
  return user?.role === "lawyer";
}

export function isClient(user?: User) {
  if (isEmptyUser(user)) {
    return false;
  }
  return user?.role === "client";
}

export function getCompleteName(user?: User) {
  if (!user || isEmptyUser(user)) {
    return "";
  }

  return `${user.name} ${user.last_name}`
}

export function getLawyerFormalName(user?: User) {
  if (!user || isEmptyUser(user)) {
    return "";
  }

	if (!user.gender || user.gender === null || user.gender === "") {
    return getCompleteName(user);
	}

	if (user.gender === "male") {
    return `Dr. ${user.name} ${user.last_name}`
	} else {
    return `Dra. ${user.name} ${user.last_name}`
	}
}
